import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'reactstrap';
import React, { Component } from 'react';
import { PAYMENT_METHOD } from 'Types/constants';

const paymentBadgeFormatter = paymentStatus => {
  let color = '';
  let icon = '';
  let text = '';
  switch (paymentStatus) {
    case 'PAID':
      color = 'success';
      icon = 'check';
      text = 'PAID';
      break;
    case 'NOT_PAID':
      color = 'danger';
      icon = 'ban';
      text = 'NOT PAID';
      break;
    case 'PART_PAID':
      color = 'warning';
      icon = 'stream';
      text = 'PART PAID';
      break;
    default:
      color = 'danger';
      icon = 'ban';
      text = 'NOT PAID';
  }
  return (
    <Badge color={`soft-${color}`} className="rounded-capsule">
      {text}
      <FontAwesomeIcon icon={icon} transform="shrink-2" className="ml-1" />
    </Badge>
  );
};

const paymentMethodFormatter = paymentMethod => {
  let color = '';
  let icon = '';
  let text = '';
  switch (paymentMethod) {
    case PAYMENT_METHOD.ONLINE:
      color = 'info';
      icon = 'credit-card';
      text = 'ELECTRONIC';
      break;
    case PAYMENT_METHOD.MANUAL:
      color = 'warning';
      icon = 'hand-holding-dollar';
      text = 'MANUAL';
      break;
    default:
      color = 'secondary';
      icon = 'question-circle';
      text = paymentMethod || 'UNKNOWN';
  }
  return (
    <Badge color={`soft-${color}`} className="rounded-capsule">
      {text}
      <FontAwesomeIcon icon={icon} transform="shrink-2" className="ml-1" />
    </Badge>
  );
};

export { paymentBadgeFormatter, paymentMethodFormatter };
export default paymentBadgeFormatter;
